import React from "react";
import './SnackBar.scss';

export const SnackBar = ({ snack }) => {
    return (
        <div className={`SnackBar ${snack ? 'show' : ''}`} >
            {snack}
        </div>
    );
};